export default "__VITE_ASSET__d6ee1510__"